import { action, makeObservable, observable, reaction } from 'mobx';
import { driftGameService } from '../driftService/gameService';
import { soundService } from '../../../services/baseSoundService/soundService';
import { DriftSoundNames } from '../driftCore/constants/sounds';
import { driftBetsStore } from './betStore';
import { userInfoStore } from '../../../store/userInfoStore';
import { applicationStore } from '../../../store/applicationStore';
import { driftDrawerService } from '../driftService/gameDrawerService';
import { freeBetStore } from '../../../store/freeBetStore';

class DriftGameStore {
  time = 5;

  isLose = false;

  isWin = false;

  isDoSpinState = true;

  isHeldButton = false;

  isShowCashOut = false;

  isOnceClicked = false;

  isAllowCashOut = false;

  timerAnimationDelay = 0;

  isBetButtonDisabled = false;

  isAllowedNextReportInvoke = false;

  isAllowedNextDoSpinInvoke = true;

  isHideWin = true;

  constructor() {
    makeObservable(this, {
      time: observable,
      isLose: observable,
      isWin: observable,
      isHideWin: observable,
      isHeldButton: observable,
      isShowCashOut: observable,
      isDoSpinState: observable,
      isAllowCashOut: observable,
      isOnceClicked: observable,
      isBetButtonDisabled: observable,
      timerAnimationDelay: observable,
      isAllowedNextReportInvoke: observable,
      isAllowedNextDoSpinInvoke: observable,
      setTimer: action.bound,
      setIsLose: action.bound,
      setIsWin: action.bound,
      setIsHideWin: action.bound,
      setIsHeldButton: action.bound,
      setIsDoSpinState: action.bound,
      setIsShowCashOut: action.bound,
      setIsOnceClicked: action.bound,
      setIsAllowCashOut: action.bound,
      setIsBetButtonDisabled: action.bound,
      setTimerAnimationDelay: action.bound,
      setIsAllowedNextReportInvoke: action.bound,
      setIsAllowedNextDoSpinInvoke: action.bound,
    });
    reaction(
      () => applicationStore.isConnectionLost,
      () => {
        driftDrawerService.resetAnimationState();
        driftBetsStore.setRoundResult(null);
        this.setIsHeldButton(false);
        this.setIsAllowCashOut(false);
        this.setIsDoSpinState(true);
        this.setIsOnceClicked(false);
      }
    );
    reaction(
      () => this.isHeldButton + driftBetsStore.roundResult,
      (value) => {
        const { setIsAllowedChangeCurrency } = userInfoStore;
        const { currentFreeBet } = freeBetStore;
        setIsAllowedChangeCurrency(!value);
        if (currentFreeBet && !currentFreeBet.remainingCount && !value) {
          freeBetStore.setIsShowFreeBetPopup(true);
        }
      }
    );

    reaction(
      () => this.isHeldButton + driftBetsStore.roundResult,
      () => {
        if (!this.isHeldButton && driftBetsStore.roundResult) {
          soundService.play(DriftSoundNames.Timer, true);
        } else {
          soundService.stop(DriftSoundNames.Timer);
        }
      }
    );
  }

  setIsAllowCashOut(bool) {
    this.isAllowCashOut = bool;
  }

  setIsLose(bool) {
    this.isLose = bool;
  }

  setIsWin(bool) {
    this.isWin = bool;
  }

  setIsHideWin(bool) {
    this.isHideWin = bool;
  }

  setIsShowCashOut(bool) {
    this.isShowCashOut = bool;
  }

  setTimer(time) {
    this.time = time;
    if (!+time) {
      driftGameService.sendWorker(null);
      driftGameService.sendCashOut();
    }
  }

  setIsBetButtonDisabled(value) {
    this.isBetButtonDisabled = value;
  }

  setIsHeldButton(value) {
    this.isHeldButton = value;
  }

  setIsOnceClicked(value) {
    this.isOnceClicked = value;
  }

  setIsAllowedNextReportInvoke(value) {
    this.isAllowedNextReportInvoke = value;
  }

  setIsAllowedNextDoSpinInvoke(value) {
    this.isAllowedNextDoSpinInvoke = value;
  }

  setTimerAnimationDelay(delay) {
    this.timerAnimationDelay = delay;
  }

  setIsDoSpinState(value) {
    this.isDoSpinState = value;
  }

  resetStore() {
    this.time = 5;
    this.isLose = false;
    this.isDoSpinState = true;
    this.isHeldButton = false;
    this.isShowCashOut = false;
    this.isOnceClicked = false;
    this.isAllowCashOut = false;
    this.timerAnimationDelay = 0;
    this.isBetButtonDisabled = false;
    this.isAllowedNextReportInvoke = false;
    this.isAllowedNextDoSpinInvoke = true;
  }
}

export const driftGameStore = new DriftGameStore();
